import { render, staticRenderFns } from "./ParamUnidadeMedida.vue?vue&type=template&id=9a25560a"
import script from "./ParamUnidadeMedida.vue?vue&type=script&lang=js"
export * from "./ParamUnidadeMedida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports